(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb351"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb351"] = parcelRequire;
}
parcelRequire.register("fFhxl", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $b67849c853d41c05$export$6503ec6e8aabbaf; }, function (v) { return $b67849c853d41c05$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $b67849c853d41c05$export$f7ad0328861e2f03; }, function (v) { return $b67849c853d41c05$export$f7ad0328861e2f03 = v; });
var $b67849c853d41c05$export$6503ec6e8aabbaf;
var $b67849c853d41c05$export$f7ad0328861e2f03;
"use strict";
var $b67849c853d41c05$var$mapping = {};
function $b67849c853d41c05$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$b67849c853d41c05$var$mapping[keys[i]] = pairs[keys[i]];
}
function $b67849c853d41c05$var$resolve(id) {
    var resolved = $b67849c853d41c05$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$b67849c853d41c05$export$6503ec6e8aabbaf = $b67849c853d41c05$var$register;
$b67849c853d41c05$export$f7ad0328861e2f03 = $b67849c853d41c05$var$resolve;

});

var $8959b24e241e6d12$exports = {};

(parcelRequire("fFhxl")).register(JSON.parse('{"3PIvK":"index.776de6b3.js","15bra":"frame.5b787238.svg","hB2Ze":"SoundFX3-AnyButton.6d3cc61a.mp3","ksDbD":"trophy-1st.6a93664c.svg","7L5aG":"trophy-2nd.369eda49.svg","9J5ZF":"trophy-3rd.96f8ea6f.svg","5RrR6":"trophy.5ff339db.svg","ldfbI":"seemode.c4e19dcb.svg","bQ9c2":"background.dffda619.svg","aS8OV":"panel.502c2c04.svg","9Uo39":"SoundFX1-TRbutton.c4e3b494.mp3","6b6cc":"clock.a4ec9920.svg","ktZBX":"SoundFX2-Win.1d21e86d.mp3","39v1z":"UltrasoundImage.de505c29.svg","kSNJe":"BGsoundscape1.af483d6d.mp3","jwIcY":"BGsoundscape2.c6a7cbd9.mp3"}'));

})();
//# sourceMappingURL=index.0e85e780.js.map
